import React, { ReactElement, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './index.less';
import { getLoginInfoPromise } from '../../../../utils/common';
import { formateDatePile } from '../../../../utils/common';
import bigCircular from '@assets/big-circular.png';
import { getAfterSaleProgress } from '../../../../api/filling-pile';
import redCirdular from '@assets/red-circular.png';
import greyCircular from '@assets/grey-circular.png';

const OldAfterSales = (): ReactElement => {
  const loc = useLocation();
  const orderNo: any = new URLSearchParams(loc.search).get('orderNo');
  const [orderInfo, setOrderInfo] = useState<any>();
  const setTitle = () => {
    document.title = '售后服务';
  };
  useEffect(() => {
    setTitle();
    getLoginInfoPromise().then(res => {
      getAfterSaleProgress({
        uid: res.uid,
        name: res.nickname,
        orderNo: orderNo
      }).then(info => {
        console.log(info);
        setOrderInfo(info.data);
      });
    });
  }, []);
  return (
    <div className="old-install">
      <div className="content">
        <div className="completed">
          <div>
            <p>完成维修</p>
          </div>
          <img
            src={
              orderInfo &&
              orderInfo.orderStauts >= 5 &&
              orderInfo.orderStauts <= 7
                ? bigCircular
                : greyCircular
            }
            alt=""
            className="bigCircular"
          />
        </div>
        <div className="completed">
          <div>
            <p>维修</p>
          </div>
          <img
            src={
              orderInfo &&
              orderInfo.orderStatus > 2 &&
              orderInfo.orderStatus <= 5
                ? bigCircular
                : greyCircular
            }
            alt=""
            className="bigCircular"
          />
        </div>

        {orderInfo && orderInfo.orderStatus === 8 ? (
          <div className="completed">
            <div>
              <p>中途结束</p>
            </div>
            <img src={redCirdular} alt="" className="bigCircular" />
          </div>
        ) : (
          ''
        )}
        {orderInfo && (
          <div className="title">
            <div className="text">售后申请</div>
            <img src={bigCircular} alt="" className="bigCircular" />
            <div className="time">
              申请时间：{orderInfo && formateDatePile(orderInfo.applyTime)}
            </div>
          </div>
        )}
      </div>
      <div className="contact">
        {orderInfo && orderInfo.serviceProviderManagerPhone ? (
          <a href={`tel:${orderInfo.serviceProviderManagerPhone}`}>
            联系家充管家
          </a>
        ) : (
          <div className="text">正在为您分配家充服务管家</div>
        )}
      </div>
    </div>
  );
};
export default OldAfterSales;
